var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-full"},[_c('h1',[_vm._v("Page Not Found")]),_c('p',[_vm._v("\n    Sorry, Page Not Found. Back to\n    "),_c('router-link',{attrs:{"to":{name: 'Home'}}},[_vm._v("\n      Home\n    ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }